@if (interactive) {
<button
  type="button"
  class="share-row"
  [attr.aria-expanded]="expanded"
  [attr.aria-controls]="expanded === null ? null : controlsId"
  (click)="onPress()"
>
  <ng-container *ngTemplateOutlet="content" />
</button>
} @else {
<div class="share-row share-row--static">
  <ng-container *ngTemplateOutlet="content" />
</div>
}

<ng-template #content>
  @if (row; as vm) {
  @switch (vm.leading?.kind) {
  @case ('icon') {
  <img class="icon" [src]="$any(vm.leading).src" alt="" aria-hidden="true" />
  }
  @case ('initials') {
  <span class="icon icon--initials" aria-hidden="true">{{ $any(vm.leading).text }}</span>
  }
  }
  <span class="share-body">
    <span class="share-name">{{ vm.name }}</span>
    <span class="share-meta">{{ vm.meta }}</span>
    @if (showShare) {
    <span class="share-bar" aria-hidden="true">
      <span class="share-bar-fill" [style.width.%]="share ?? 0"></span>
    </span>
    } @if (showShare && vm.caption) {
    <span class="share-meta share-caption">{{ vm.caption }}</span>
    }
  </span>
  @if (vm.amount) {
  <span class="share-amount">{{ vm.amount }}</span>
  }
  } @else if (product) {
  <img class="icon" [src]="icon" alt="" aria-hidden="true" />
  <span class="share-body">
    <span class="share-name">{{ product.name }}</span>
    <span class="share-meta">
      {{ soldLabelKey | translate: { count: sold } }}
      @if (share !== null) {
      · {{ "products.share-of-total" | translate: { percent: share } }}
      }
    </span>
    @if (showShare) {
    <span class="share-bar" aria-hidden="true">
      <span class="share-bar-fill" [style.width.%]="share ?? 0"></span>
    </span>
    }
  </span>
  }
  @if (expanded !== null) {
  <ion-icon
    class="share-chevron"
    [class.share-chevron--open]="expanded"
    name="chevron-down-outline"
    aria-hidden="true"
  />
  }
</ng-template>
